export const STORAGE_PREFIX = 'filters-';

export default {
    namespaced: true,
    state: {
        currentFilters: {},
    },
    mutations: {
        setFilter(state, { id, filter }) {
            state.currentFilters[`${STORAGE_PREFIX}${id}`] = { ...state.currentFilters[`${STORAGE_PREFIX}${id}`], ...filter };
            state.currentFilters = { ...state.currentFilters };
        },
        setFilters(state, { id, filters }) {
            state.currentFilters[`${STORAGE_PREFIX}${id}`] = { ...filters };
            state.currentFilters = { ...state.currentFilters };
        },
        removeFilter(state, id) {
            delete state.currentFilters[`${STORAGE_PREFIX}${id}`];
        },
    },
    actions: {
        removeFilter({ dispatch }, { id, filterKey }) {
            dispatch('rememberFilter', { id, key: filterKey, value: '' });
        },
        rememberFilter({ commit, state }, { id, key, value }) {
            const obj = {};
            obj[key] = value;

            commit('setFilter', { id, filter: obj });

            try {
                localStorage.setItem(`${STORAGE_PREFIX}${id}`, JSON.stringify(state.currentFilters[`${STORAGE_PREFIX}${id}`]));
                // eslint-disable-next-line no-empty
            } catch (e) {}
        },
        getFilterValue({ state }, { id, filterKey }) {
            return state.currentFilters[`${STORAGE_PREFIX}${id}`] ? state.currentFilters[`${STORAGE_PREFIX}${id}`][filterKey] : null;
        },
        loadFiltersFromStorage({ commit }, id) {
            const filters = localStorage.getItem(`${STORAGE_PREFIX}${id}`);
            if (filters) {
                commit('setFilters', { id, filters: JSON.parse(filters) });
            }
        },
        hasFilters({ state }, id) {
            const hasFilters = !!Object.keys(state.currentFilters[`${STORAGE_PREFIX}${id}`]).length;

            if (!hasFilters) {
                throw new Error('Does not have any filters');
            }
        },
        clearFilterFromStorage({ commit }, id) {
            commit('removeFilter', id);
            localStorage.removeItem(`${STORAGE_PREFIX}${id}`);
        },
    },
};
